/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "37c2c8fe10a8e7988b84416a90083181a8bbfb18";
